export const deviceTypesArray = ["All", "Android", "IOS", "Desktop"];
export const swingTypesArray = [
  "All",
  "Full Swing",
  "Short Game",
  "Putting",
  "Bunker",
  "Scan",
];

export const orientationTypesArray = [
  "All",
  "Face On",
  "Down The Line",
  "Both",
];

export const categoryTypesArray = [
  "All",
  "My Swings",
  "Community Swings",
  "Public Swings",
];

export const clubTypesArray = ["All", "Iron", "Driver", "Wedge"];
export const poseStatusTypesArray = ["All", "done", "error"];
export const clubStatusTypesArray = ["All", "done", "error"];

export const dropDownTitle = {
  device: "device",
  orientation: "orientation",
  category: "category",
  swing: "swing",
  poseStatus: "poseStatus",
  clubStatus: "clubStatus",
  processingTime: "processingTime",
};

export const initialValues = {
  timeInterval: "All",
};

export const queryParamsValues = {
  swing: "swing",
  orientation: "orientation",
  poseStatus: "poseStatus",
  clubStatus: "clubStatus",
  device: "device",
  to: "to",
  from: "from",
  timeInterval: "timeInterval",
  processingTime: "processingTime",
};

export const deviceTypesLabels = {
  dc1: "DES",
  iOS: "IOS",
  and: "AND",
};

export const defaultValue = "All";
export const defaultValueProcessingTime = [0, 3000];
export const dateDropDownValues = [
  "Today",
  "Yesterday",
  "Last 7 days",
  "Last 30 Days",
  "All",
];

export const dropDownDateObject = {
  [dateDropDownValues[0]]: "today",
  [dateDropDownValues[1]]: "yesterday",
  [dateDropDownValues[2]]: "week",
  [dateDropDownValues[3]]: "month",
  [dateDropDownValues[4]]: "all",
};

const today = new Date();
const yesterday = new Date(new Date().setDate(new Date().getDate() - 1));

export const dateObject = {
  today: {
    from: today,
    to: today,
  },
  yesterday: {
    from: yesterday,
    to: yesterday,
  },
  week: {
    from: new Date(new Date().setDate(new Date().getDate() - 8)),
    to: yesterday,
  },
  month: {
    from: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    to: yesterday,
  },

  all: {
    from: null,
    to: null,
  },
};

export const QUERY_PARAMS_OBJ: any = {
  swing: "swingType",
  orientation: "orientationType",
  poseStatus: "poseStatus",
  clubStatus: "clubStatus",
  device: "deviceType",
  to: "endDate",
  from: "startDate",
  timeInterval: "timeInterval",
  processingTime: "processingTime",
};

export const swingTypes = {
  "Full Swing": "Full Swing",
  "Short Game": "Short Game",
  Putting: "Putting",
  Bunker: "Bunker",
};

export const QUERY_OPT_TYPE = {
  delete: "remove",
};

export const EXERCISE_GENRE_Obj: any = {
  Jump: ["#EFAC52", 0.1, 0.3],
  "Push Up": ["#DFE6B2", 0.25, 0.6],
  "Ball Throw": ["#C5E4EB", 0.25, 0.6],
  Rotations: ["#EFAC52", 0.1, 0.3],
  Tilts: ["#DFE6B2", 0.25, 0.6],
  Bends: ["#C5E4EB", 0.25, 0.6],
  "Dead Lift": ["#EFAC52", 0.1, 0.3],
  "Pull Ups": ["#DFE6B2", 0.25, 0.6],
  Squats: ["#C5E4EB", 0.25, 0.6],
  "Power Screening": ["#EFAC52", 0.1, 0.3],
  "Mobility Screening": ["#DFE6B2", 0.25, 0.6],
  "Basic Screening": ["#C5E4EB", 0.25, 0.6],
};

export const MAIN_CATEGORY_OBJ: any = {
  Test: ["#33B647", 0.15, 0.3],
  Scan: ["#E6F1F8", 0.3, 0.7],
  Screening: ["#F4BD00", 0.25, 0.6],
};

export const TEST_CATEGORY_OBJ: any = {
  Power: ["#D2F4FB", 0.3, 0.8],
  "Mobility Test": ["#FEE8CC", 0.3, 0.8],
  "Strength Training": ["#EAEDF1", 0.25, 0.6],
};
